const GET_PLAN_LIST_REQUEST = "GET_PLAN_LIST_REQUEST";
const GET_PLAN_LIST_COMPLETED = "GET_PLAN_LIST_COMPLETED";
const GET_PLAN_LIST_ERROR = "GET_PLAN_LIST_ERROR";

const GET_PLAN_CARD_REQUEST = "GET_PLAN_CARD_REQUEST";
const GET_PLAN_CARD_COMPLETED = "GET_PLAN_CARD_COMPLETED";
const GET_PLAN_CARD_ERROR = "GET_PLAN_CARD_ERROR";

const GET_PLAN_SYSTEM_REQUEST = "GET_PLAN_SYSTEM_REQUEST";
const GET_PLAN_SYSTEM_COMPLETED = "GET_PLAN_SYSTEM_COMPLETED";
const GET_PLAN_SYSTEM_ERROR = "GET_PLAN_SYSTEM_ERROR";

const GET_PLAN_MAIN_REQUEST = "GET_PLAN_MAIN_REQUEST";
const GET_PLAN_MAIN_COMPLETED = "GET_PLAN_MAIN_COMPLETED";
const GET_PLAN_MAIN_ERROR = "GET_PLAN_MAIN_ERROR";

const GET_ORG_LIST_REQUEST = "GET_ORG_LIST_REQUEST";
const GET_ORG_LIST_COMPLETED = "GET_ORG_LIST_COMPLETED";
const GET_ORG_LIST_ERROR = "GET_ORG_LIST_ERROR";

const GET_PROGRAM_LIST_REQUEST = "GET_PROGRAM_LIST_REQUEST";
const GET_PROGRAM_LIST_COMPLETED = "GET_PROGRAM_LIST_COMPLETED";
const GET_PROGRAM_LIST_ERROR = "GET_PROGRAM_LIST_ERROR";

const CREATE_PLAN_REQUEST = "CREATE_PLAN_REQUEST";
const CREATE_PLAN_COMPLETED = "CREATE_PLAN_COMPLETED";
const CREATE_PLAN_ERROR = "CREATE_PLAN_ERROR";

const UPDATE_PLAN_REQUEST = "UPDATE_PLAN_REQUEST";
const UPDATE_PLAN_COMPLETED = "UPDATE_PLAN_COMPLETED";
const UPDATE_PLAN_ERROR = "UPDATE_PLAN_ERROR";

const CREATE_GROUP_REQUEST = "CREATE_GROUP_REQUEST";
const CREATE_GROUP_COMPLETED = "CREATE_GROUP_COMPLETED";
const CREATE_GROUP_ERROR = "CREATE_GROUP_ERROR";

const UPDATE_GROUP_REQUEST = "UPDATE_GROUP_REQUEST";
const UPDATE_GROUP_COMPLETED = "UPDATE_GROUP_COMPLETED";
const UPDATE_GROUP_ERROR = "UPDATE_GROUP_ERROR";

const REMOVE_GROUP_REQUEST = "REMOVE_GROUP_REQUEST";
const REMOVE_GROUP_COMPLETED = "REMOVE_GROUP_COMPLETED";
const REMOVE_GROUP_ERROR = "REMOVE_GROUP_ERROR";

const GET_PLAN_GROUP_LIST_REQUEST = "GET_PLAN_GROUP_LIST_REQUEST";
const GET_PLAN_GROUP_LIST_COMPLETED = "GET_PLAN_GROUP_LIST_COMPLETED";
const GET_PLAN_GROUP_LIST_ERROR = "GET_PLAN_GROUP_LIST_ERROR";

const GET_PLAN_WAITING_LIST_REQUEST = "GET_PLAN_WAITING_LIST_REQUEST";
const GET_PLAN_WAITING_LIST_COMPLETED = "GET_PLAN_WAITING_LIST_COMPLETED";
const GET_PLAN_WAITING_LIST_ERROR = "GET_PLAN_WAITING_LIST_ERROR";

const SET_GROUP_REQUEST = "SET_GROUP_REQUEST";
const SET_GROUP_COMPLETED = "SET_GROUP_COMPLETED";
const SET_GROUP_ERROR = "SET_GROUP_LIST_ERROR";

const CHANGE_STATE_PLAN_REQUEST = "CHANGE_STATE_PLAN_REQUEST";
const CHANGE_STATE_PLAN_COMPLETED = "CHANGE_STATE_PLAN_COMPLETED";
const CHANGE_STATE_PLAN_ERROR = "CHANGE_STATE_PLAN_ERROR";

export default {
  GET_PLAN_LIST_REQUEST,
  GET_PLAN_LIST_COMPLETED,
  GET_PLAN_LIST_ERROR,
  GET_PLAN_CARD_REQUEST,
  GET_PLAN_CARD_COMPLETED,
  GET_PLAN_CARD_ERROR,
  GET_PLAN_SYSTEM_REQUEST,
  GET_PLAN_SYSTEM_COMPLETED,
  GET_PLAN_SYSTEM_ERROR,
  GET_PLAN_MAIN_REQUEST,
  GET_PLAN_MAIN_COMPLETED,
  GET_PLAN_MAIN_ERROR,
  GET_ORG_LIST_REQUEST,
  GET_ORG_LIST_COMPLETED,
  GET_ORG_LIST_ERROR,
  GET_PROGRAM_LIST_REQUEST,
  GET_PROGRAM_LIST_COMPLETED,
  GET_PROGRAM_LIST_ERROR,
  CREATE_PLAN_REQUEST,
  CREATE_PLAN_COMPLETED,
  CREATE_PLAN_ERROR,
  UPDATE_PLAN_REQUEST,
  UPDATE_PLAN_COMPLETED,
  UPDATE_PLAN_ERROR,
  CREATE_GROUP_REQUEST,
  CREATE_GROUP_COMPLETED,
  CREATE_GROUP_ERROR,
  UPDATE_GROUP_REQUEST,
  UPDATE_GROUP_COMPLETED,
  UPDATE_GROUP_ERROR,
  REMOVE_GROUP_REQUEST,
  REMOVE_GROUP_COMPLETED,
  REMOVE_GROUP_ERROR,
  GET_PLAN_GROUP_LIST_REQUEST,
  GET_PLAN_GROUP_LIST_COMPLETED,
  GET_PLAN_GROUP_LIST_ERROR,
  GET_PLAN_WAITING_LIST_REQUEST,
  GET_PLAN_WAITING_LIST_COMPLETED,
  GET_PLAN_WAITING_LIST_ERROR,
  SET_GROUP_REQUEST,
  SET_GROUP_COMPLETED,
  SET_GROUP_ERROR,

  CHANGE_STATE_PLAN_REQUEST,
  CHANGE_STATE_PLAN_COMPLETED,
  CHANGE_STATE_PLAN_ERROR
};
